<template>
  <div class="answerCompare">
    <!-- header -->
    <div class="header">
      <span>当前课程id： {{ params.courseId }}</span>
      <span>当前班级id： {{ params.classId }}</span>
      <span>当前用户ID： {{ params.userId }}</span>
      <span>试题id： {{ params.questionId }}</span>
    </div>
    <div class="main">
      <!-- content -->
      <div class="content">
        <!-- 老师的标准答案 -->
        <div class="left">
          <h3>老师的标准答案：</h3>
          <ul>
            <li v-for="(item, index) in teacherAnswer" :key="index">
              <h3> 步骤 {{ index + 1 }}： {{ item.eventName }} （{{
                item.formName
                }}）</h3>
              <p>
                唯一标识字段：<br/>
                <json-viewer
                  v-if="item.formMapper"
                  :value="item.formMapper"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
                <json-viewer
                  v-else
                  value="无"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
              </p>
              <p style="color: cyan;">
                标准答案内容：<br/>
                <json-viewer
                  :value="item.value"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
              </p>
              <p>
                协议： <br/>
                <json-viewer
                  v-if="item.aggrementMapper"
                  :value="item.aggrementMapper"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
                <json-viewer
                  v-else
                  value="无"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
              </p>
              <p>
                权重：<br/>
                <json-viewer
                  v-if="item.weightMapper"
                  :value="item.weightMapper"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
                <json-viewer
                  v-else
                  value="无"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
              </p>
            </li>
          </ul>
        </div>
        <!-- 学生作答的有效内容 -->
        <div class="right">
          <h3>学生作答的有效内容：</h3>
          <ul>
            <li v-for="(item, index) in studentAnswer" :key="index">
              <h3>步骤 {{ index + 1 }}： {{ item.form_name }}
                <span class="fuzhianniu" @click="copyStudentContent(item)"
                >复制埋点</span>
              </h3>
              <p>
                唯一标识字段：<br/>
                <json-viewer
                  :value="item.form_mapper"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
              </p>
              <p style="color: cyan;">
                学生作答内容： <br/>
                <json-viewer
                  :value="item.detail_content"
                  :expand-depth="1"
                  boxed
                  sort
                ></json-viewer>
              </p>
              <p>当前用户操作行为： {{ item.signStatus == 0 ? '正常' : '删除' }}</p>
              <p>操作时间： {{ item.create_date }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "../api/answerCompare.js";

  export default {
    name: "answerCompare",
    components: {},
    data() {
      return {
        params: {},
        teacherAnswer: [],
        studentAnswer: [],
        type: this.$route.query.type,
      };
    },
    created() {
      this.params = {
        classId: this.$route.query.classId,
        userId: this.$route.query.userId,
        courseId: this.$route.query.courseId,
        questionId: this.$route.query.questionId,
        teamId: this.$route.query.teamId,
      };
      if (this.type == 3) {
        this.getAnswerCompareInfo(this.params);
      } else {
        this.getIndividualAnswer(this.params);
      }
    },
    mounted() {
    },
    methods: {
      getIndividualAnswer(obj) {
        api.getIndividualAnswer(obj).then(res => {
          if (res.code == "0") {
            if (res.data && res.data.standAnswer) {
               this.getTeacherValue(res.data.standAnswer)
            }
            if (res.data && res.data.studentList.length) {
               this.getStudentValue(res.data.studentList)
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      },

      getAnswerCompareInfo(obj) {
        api.post_complex_score_compare_select([obj]).then(res => {
          if (res.code == "0") {
            if (res.data && res.data.standAnswer) {
              this.getTeacherValue(res.data.standAnswer)
            }
            if (res.data && res.data.studentList.length) {
              this.getStudentValue(res.data.studentList)
            }
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          console.log(err);
        })
      },
      getTeacherValue(standAnswer){
        this.teacherAnswer = this.$setJsonBig(standAnswer);

        // 处理 formName 为 "manualEvidenceForm" 的排序
        [].forEach.call(this.teacherAnswer, item => {

          if (item.value.form && item.value.form.configure) {
            item['formName'] = item.value.form.aggrementMapper;
            item['formMapper'] = item.value.form.formMapper;
            item['weightMapper'] = item.value.form.weightMapper;
            item['formName'] = item.value.form.formName;

            delete item.value.form.aggrementMapper;
            delete item.value.form.formMapper;
            delete item.value.form.weightMapper;
            delete item.value.form.configure.formName;
          } else {
            item['aggrementMapper'] = item.value.aggrementMapper;
            item['formName'] = item.value.formName;
            item['formMapper'] = item.value.formMapper;
            item['weightMapper'] = item.value.weightMapper;

            delete item.value.aggrementMapper;
            delete item.value.formMapper;
            delete item.value.weightMapper;
            delete item.value.formName;
            delete item.value.imageMapper;
          }

          if (item.value.formName === "manualEvidenceForm") {
            item.value.entrys = item.value.entrys.sort(this.getSortFun('asc', 'accountId'));
            item.value.formMapper = item.value.formMapper.sort(this.getSortFun('asc', 'accountId'));
          }
        });
      },
      getStudentValue(studentList){
        [].forEach.call(studentList, (item) => {
          try {
            item.form_mapper = this.$setJsonBig(item.form_mapper);
          } catch (e) {
            console.log("--大赛埋点--form_mapper-结构不正确-", e);
          }
          try {
            item.detail_content = this.$setJsonBig(item.detail_content);
          } catch (e) {
            console.error("--detail_content-结构不正确-", e);
          }
        });
        this.studentAnswer = studentList;
      },
      getSortFun(order, sortBy) {
        /**
         * @param order desc 降序   asc 升序
         * @param sortBy 排序字段
         * */
        var ordAlpah = (order == 'asc') ? '>' : '<';
        var sortFun = new Function('a', 'b', 'return a.' + sortBy + ordAlpah + 'b.' + sortBy + '?1:-1');
        return sortFun;
      },
      // 复制埋点
      copyStudentContent(item) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(JSON.stringify(item))
            .then(() => {
              this.$message.success("复制成功");
            })
            .catch(() => {
              this.$message.success("复制失败");
            });
        } else {
          // 创建text area
          const textArea = document.createElement("textarea");
          textArea.value = JSON.stringify(item);
          // 使text area不在viewport，同时设置不可见
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          return new Promise((resolve, reject) => {
            // 执行复制命令并移除文本框
            document.execCommand("copy")
              ? resolve()
              : reject(new Error("出错了"));
            textArea.remove();
          }).then(
            () => {
              this.$message.success("复制成功");
            },
            () => {
              this.$message.success("复制失败");
            }
          );
        }
      },


    }
  };
</script>

<style scoped lang="scss">
  .answerCompare {
    width: 100%;
    height: 100%;
    background: #F5F5F5;

    .fuzhianniu {
      font-size: 13px;
      font-weight: 400;
      display: inline-block;
      margin-left: 20px;
      color: #4589e9;
      cursor: pointer;

      &:hover {
        color: #00aeff;
      }
    }

    .header {
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      font-size: 16px;
      color: #ffffff;
      background-color: #2B2A33;
      padding: 15px 0;
    }

    .main {
      width: 85%;
      min-width: 900px;
      height: 100%;
      margin: 0 auto;
      background: #FFFFFF;

      .content {
        width: 100%;
        height: calc(100% - 60px);
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;

        h3 {
          font-size: 18px;
          font-weight: bolder;
          color: #0D141E;
          margin-bottom: 10px;
        }

        ul li {
          padding-left: 50px;
          margin-bottom: 30px;

          &:nth-of-type(1) {
            margin-top: 30px;
          }

          p {
            font-size: 14px;
            line-height: 20px;
            padding: 5px;

            div {
              margin-top: 5px;
            }
          }
        }

        .left, .right {
          width: 49%;
          height: 100%;
          padding: 10px;
          overflow: auto;
        }

        .left {
          border-right: 1px solid black;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/answerCompare.vue